function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 2884"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group 2881"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path 656 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2031 30.75C15.6508 30.75 15.2031 30.3023 15.2031 29.75L15.2031 17.6016C15.2031 16.6464 14.8237 15.7303 14.1482 15.0549C13.4728 14.3795 12.5567 14 11.6015 14C10.6463 14 9.73017 14.3795 9.05473 15.0549C8.37929 15.7303 7.99983 16.6464 7.99983 17.6016L7.99983 29.75C7.99983 30.3023 7.55211 30.75 6.99983 30.75C6.44754 30.75 5.99983 30.3023 5.99983 29.75L5.99983 17.6016C5.99983 16.116 6.59 14.6912 7.64051 13.6407C8.69103 12.5902 10.1158 12 11.6015 12C13.0871 12 14.5119 12.5902 15.5624 13.6407C16.613 14.6912 17.2031 16.116 17.2031 17.6016V29.75C17.2031 30.3023 16.7554 30.75 16.2031 30.75Z",
  fill: "#626A84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path 657 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 21.28C6 20.7277 6.44772 20.28 7 20.28H16.2033C16.7556 20.28 17.2033 20.7277 17.2033 21.28C17.2033 21.8323 16.7556 22.28 16.2033 22.28H7C6.44772 22.28 6 21.8323 6 21.28Z",
  fill: "#626A84"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 1242"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path 658 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.2539 22.936C19.2539 22.3838 19.7016 21.936 20.2539 21.936H26.144C26.6963 21.936 27.144 22.3838 27.144 22.936C27.144 23.4883 26.6963 23.936 26.144 23.936H20.2539C19.7016 23.936 19.2539 23.4883 19.2539 22.936Z",
  fill: "#626A84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path 659 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.1992 18.9939C23.7515 18.9939 24.1992 19.4416 24.1992 19.9939V25.884C24.1992 26.4363 23.7515 26.884 23.1992 26.884C22.6469 26.884 22.1992 26.4363 22.1992 25.884V19.9939C22.1992 19.4416 22.6469 18.9939 23.1992 18.9939Z",
  fill: "#626A84"
}))), /*#__PURE__*/React.createElement("path", {
  id: "Vector (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 6C3.34315 6 2 7.34315 2 9V33C2 34.6569 3.34315 36 5 36H29C30.6569 36 32 34.6569 32 33V9C32 7.34315 30.6569 6 29 6H5ZM0 9C0 6.23858 2.23858 4 5 4H29C31.7614 4 34 6.23858 34 9V33C34 35.7614 31.7614 38 29 38H5C2.23858 38 0 35.7614 0 33V9Z",
  fill: "#626A84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector (Stroke)_2",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 0C25.5523 0 26 0.447715 26 1V9C26 9.55229 25.5523 10 25 10C24.4477 10 24 9.55229 24 9V1C24 0.447715 24.4477 0 25 0Z",
  fill: "#626A84"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector (Stroke)_3",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 0C9.55228 0 10 0.447715 10 1V9C10 9.55229 9.55228 10 9 10C8.44772 10 8 9.55229 8 9V1C8 0.447715 8.44772 0 9 0Z",
  fill: "#626A84"
}));

var SvgSideSemesterGrade = function SvgSideSemesterGrade(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSideSemesterGrade, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/side-semesterGrade.3c914498.svg";
export { ForwardRef as ReactComponent };